import * as PIXI from "pixi.js";
import Cookies from "universal-cookie";
import { CRTFilter } from "@pixi/filter-crt";
import { GlitchFilter } from "@pixi/filter-glitch";

import "../css/style.css";
import Fakecodeascii from '../Text/Fakeshit.txt';
import spritesh from "../images/logo/spritesheet.png";
import spritejson from "../images/logo/spritesheet.json";

export default function test() {

  
  const app = new PIXI.Application({ background: "#000000", resizeTo: window });
  var centerx = app.screen.width / 2,
    centery = app.screen.height / 2;
  app.ticker.maxFPS = 40;
  document.body.appendChild(app.view);
  const crt = new CRTFilter();
  crt.lineWidth = 0.29;
  crt.noise = 0.288;
  crt.vignetting = 0;
  const cookie = new Cookies()
  const glitch = new GlitchFilter();
  glitch.slices = 11
  glitch.offset = -7.2
  glitch.red.x = 11.8
  glitch.red.y = 2
  glitch.blue.x = 10
  glitch.blue.y = -4
  glitch.green.x = -10
  glitch.green.y = -4;

  app.stage.filters = [crt,glitch]

  onkeydown = (event) => {
    if(done === true ){
      window.location.href = "/"
    }
  };

  window.addEventListener("resize", onWindowResize, false);

  function onWindowResize() {
    var ax = app.screen.width / 2,
      ay = app.screen.height / 2;
    wholecontainer.x = ax;
    wholecontainer.y = ay;
  }

;

  const spritesheet = new PIXI.Spritesheet(
    new PIXI.BaseTexture(spritesh),
    spritejson
  );

  spritesheet.parse();
  const slogans = [
    "Build Higher.",
    "Apart Of Something More.",
    "Far Beyond, Far Above.",
    "Welcome Home, Neophyte.",
    "Defining Reality.",
    "Safe Haven And Response Directory.",
    "Callisto.",
    "ERROR! UNDEFINED CONSTRUCT!",
  ];
  const linebeam = {
    fontFamily: "Linebeam",
    fontSize: 50,
    align: "center",
    fill: ["#ffffff"],
  };

  const f3270w = {
    fontFamily: "f3270",
    fontSize: 20,
    align: "center",
    fill: ["#ffffff"],
  };
  var f3270b = {
    fontFamily: "f3270",
    fontSize: 20,
    align: "center",
    fill: ["#000000"],
  };
  const f3270co = {
    fontFamily: "f3270",
    fontSize: 15,
    fill: ["#ffffff"],
  };
  var Fakecodestring = null;
  fetch(Fakecodeascii)
  .then(r => r.text())
  .then(text => {
    Fakecodestring = text
 });

  //aaaaaahhhhhhhhhhggAHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHH
  const bottom = PIXI.Sprite.from(spritesheet.textures["Bottom.png"]);
  const left = PIXI.Sprite.from(spritesheet.textures["LeftSide.png"]);
  const right = PIXI.Sprite.from(spritesheet.textures["RightSide.png"]);
  const center = PIXI.Sprite.from(spritesheet.textures["Center.png"]);
  const strut = PIXI.Sprite.from(spritesheet.textures["Struts.png"]);
  const triangle = PIXI.Sprite.from(spritesheet.textures["Triangle.png"]);
  const logocontainer = new PIXI.Container();
  const wholecontainer = new PIXI.Container();

  const plane = new PIXI.SimplePlane(PIXI.Texture.WHITE, 10, 10);

  plane.width = app.screen.width;
  plane.height = app.screen.height - 20;
  
  const title = new PIXI.Text("", linebeam);
  const Slogan = new PIXI.Text("", f3270w);
  const Loadingstate = new PIXI.Text("", f3270w);
  const Loadingbarsides = new PIXI.Text("", f3270w);
  const Loadingbarinner = new PIXI.Text("", f3270w);
  const Loadingbartext = new PIXI.Text("", f3270w);
  const Fakecode = new PIXI.Text('', f3270co)
  const sl = slogans[Math.floor(Math.random() * slogans.length)];
  app.stage.addChild(Fakecode);
  const sprites = [
    bottom,
    left,
    right,
    strut,
    center,
    triangle,
    wholecontainer,
  ];
  sprites.forEach((sprite) => {
    sprite.y = centery;
    sprite.x = centerx;
    logocontainer.addChild(sprite);
  });


  //UGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG
  title.y = title.y + 220;
  Slogan.y = Slogan.y + 270;
  Loadingstate.y = Loadingstate.y + 310;
  Loadingbarsides.y = 350;
  Loadingbarinner.y = 339;
  Loadingbarinner.x = Loadingbarinner.x - 108;
  Loadingbartext.y = 350;
  title.anchor.set(0.5);
  Slogan.anchor.set(0.5);
  Loadingstate.anchor.set(0.5);
  Loadingbarsides.anchor.set(0.5);
  Loadingbartext.anchor.set(0.5);
  bottom.y = bottom.y + 300;
  right.x = right.x + 390;
  left.x = left.x - 360;
  strut.y = strut.y - 20;
  triangle.y = triangle.y - 20;
  left.alpha = 0;
  right.alpha = 0;
  bottom.alpha = 0;
  strut.alpha = 0;
  triangle.alpha = 0;
  Slogan.alpha = 0;
  center.alpha = 0;
  Loadingstate.alpha = 1;
  Loadingbartext.alpha = 0;
  Loadingbarsides.alpha = 0;
  Loadingbarinner.alpha = 0;
  Loadingstate.alpha = 0;
  bottom.anchor.set(spritesheet.data.init["Bottom.png"].anchor); //correct anchors
  center.anchor.set(spritesheet.data.init["Center.png"].anchor);
  right.anchor.set(spritesheet.data.init["RightSide.png"].anchor);
  left.anchor.set(spritesheet.data.init["LeftSide.png"].anchor);
  strut.anchor.set(spritesheet.data.init["Struts.png"].anchor);
  triangle.anchor.set(spritesheet.data.init["Triangle.png"].anchor);
  logocontainer.pivot.x = centerx;
  logocontainer.pivot.y = centery;





  function initlogo (){
    wholecontainer.addChild(Slogan);
    wholecontainer.addChild(title);
    wholecontainer.addChild(Loadingbarinner);
    wholecontainer.addChild(Loadingstate);
    wholecontainer.addChild(Loadingbarsides);
    wholecontainer.addChild(Loadingbartext);
    wholecontainer.addChild(logocontainer);
    app.stage.addChild(wholecontainer);
  }

  //i dont know if this is a good way of achiveing this goal but it works
  //:)

 

  const lbarframes = ["/", "-", "\\", "|"];
  var killme = null;
  var currentstate = 0; //current state
  var l = 0; //loading bar frame
  function UpdateLoading() {
    percent = Math.round((frame / totalframes) * 100); //precentage calculator'
    Loadingbartext.text = percent + "%";

    if (killme === null) {
      killme = percent + 5;
      
    }

    if (killme === percent) {
        if (Loadingbarinner.text.length >= 8  && Loadingbarinner.text.length <= 11){
            Loadingbarinner.text += "▒";
            Loadingbartext.style = f3270b
        } else {
            Loadingbarinner.text += "▒";

        }


      killme = null;
    }
    switch (percent) {
      case 0:
        currentstate = "Connecting ";
        break;
      case 20:
        currentstate = "Loading ";
        break;
      case 40:
        currentstate = "Compiling ";
        break;
      case 60:
        currentstate = "Initalizing ";
        break;
      case 80:
        currentstate = "Rendering ";
        break;
      case 100:
        currentstate = "Press [ANY KEY] To Continue ";
        break;
      default:
        break;
    }
    if (percent === 100) {
      Loadingstate.text = currentstate;
    } else {
      Loadingstate.text = currentstate + "[" + lbarframes[l] + "]";
    }
  }
  const titletext = "S.H.A.R.D";
  var lettercount = 0; //letter
  var framelock = null; //this is the holder for frames locking complicated but efficent
  function DrawTitle() {
    if (framelock === null) {
        framelock = frame + 10;
      }
      if (frame === framelock) {
        Loadingbarsides.text = "[                    ]";
        Slogan.text = sl;
        if (l !== 3) {
            l++;
        } else {
            l = 0;
        }
  
        if (title.text.length !== titletext.length) {
          title.text += titletext.split("")[lettercount];
          lettercount++;
        }
        framelock = null;
      }
  }
  const cursorframes = ['', '│']
  function DrawBios() {
    if (framelock === null) {
        framelock = frame + 10;
      }
      if (frame === framelock) {
        if (l !== 1) {
          l++;
        } else {
          l = 0;
        }
        Fakecode.text = cursorframes[l]
        framelock = null;
      }
  }

  var lc = 0; //letter code
  function WriteCode(){
    if (Fakecode.text.length !== Fakecodestring.length){
        Fakecode.text += Fakecodestring.split("")[lc]
        lc++
        Fakecode.text += Fakecodestring.split("")[lc]
        lc++
    }
  }

  var biostl = [];
  function lerp(x, y, a) {
    return (1 - a) * x + a * y;
  }
  function scalePercent(start, end) {
    return (frame - start) / (end - start);
  }

  biostl.push({
    //Play Bios shit
    start: 0,
    end: 500,
    func: () => {   

    },
  });
  
  biostl.push({
    //Flash
    start: 25,
    end: 30,
    func: () => {   
      app.stage.addChild(plane);
      if (plane.destroyed === false && frame === 29){
        plane.destroy()
        glitch.enabled = false;
      }

    },
  });

  biostl.push({
    start: 30,
    end: 29,
    func: () => {   


    },
    
  });
  biostl.push({
    //Play Bios shit
    start: 30,
    end: 500,
    func: () => {
      DrawBios()
      
    },
    
  });

  biostl.push({
    //Fade in the center
    start: 450,
    end: 500,
    func: () => {
      initlogo() 
      center.rotation -= 0.011 * 1;
      center.alpha += 0.04
    },
    
  });
    


/////////////////////////////////////////////////////////////////////////////////////////////////////
//logo timeline
////
  var logotl = [];
  logotl.push({
    //Start logo animation
    start: 0,
    end: 620,
    func: () => {

      UpdateLoading()
      WriteCode()
      DrawTitle()
    },
  });

  logotl.push({
    //Inital Rotation
    start: 0,
    end: 455,
    func: () => {
      logocontainer.rotation -= 0.0138; //fix pls
      center.rotation -= 0.009 * 1;
    },
  });

  logotl.push({
    //Fade in
    start: 60,
    end: 250,
    func: () => {
      
      var a = lerp(0, 0.001, scalePercent(60, 80));
      right.alpha += a;
      left.alpha += a;
      bottom.alpha += a;
      if (title.text.length === titletext.length){
        var b = lerp(0, 0.002, scalePercent(60, 80));
        Loadingbartext.alpha += b;
        Loadingbarsides.alpha += b;
        Loadingbarinner.alpha += b;
        Loadingstate.alpha += b;
      }
    },
  });
  logotl.push({
    //begin movement
    start: 250,
    end: 455,
    func: () => {
      var a = lerp(0, 0.1, scalePercent(60, 80));

      right.x -= a;

      left.x += a;
      bottom.y -= lerp(0, 0.06701, scalePercent(60, 80)); //fix pls
    },
  });
  logotl.push({
    //connect
    start: 455,
    end: 600,
    func: () => {
      var a = lerp(0, 0.001, scalePercent(60, 80));
      triangle.alpha += a;
      strut.alpha += a;
      Slogan.alpha += a;
    },
  });
  var percent = 0;
  var frame = 0;
  var totalframes = 500;
  var ctl = 0;
  //another day another terrible coding lesson
  //this allows multiple timelines to be added to create seperate animations 
  //i use one for the logo and one for the bios loading
  function playtimeline() {
    switch (ctl) {
        case 0:
            biostl.forEach((a) => {
                if (frame >= a.start && frame < a.end) {
                   a.func();
                }
              });
              if (frame !== totalframes) {
                frame++;
                //document.getElementById("test").innerText = frame;
              } else {
                frame = 0
                totalframes = 620
                ctl = 1
                framelock = null
              }    
            
            break;
        case 1:
            logotl.forEach((a) => {
                if (frame >= a.start && frame < a.end) {
                  a.func();
                }
              });
              if (frame !== totalframes) {
                frame++;
              } else {
                done = true;
                cookie.set('watched', true, { path: '/' });
                Fakecode.alpha = Fakecode.alpha - 0.01
              }    
            break;
        default:
            throw new Error("END OF TIMELINE")
    }

  }



  var done = false;
  app.ticker.add((delta) => {
    playtimeline();

  });
  /*
  return (
    <>
      <div>
        <p id="test" className="text-3270">
          here
        </p>
        <p id="test1" className="text-3270">
          here
        </p>
        <p id="test2" className="text-3270">
          here
        </p>
        <p id="test3" className="text-3270">
          here
        </p>
        <p id="test4" className="text-3270">
          here
        </p>
      </div> 
    </> 
  ); 
  */
}